import api from "./api";

export type JournalLine = {
  id?: string;
  ledgerCode?: string | null;
  ledgerName?: string | null;
  debit: number;
  credit: number;
  narration?: string | null;
};

export type JournalEntry = {
  id: string;
  entryNumber: string;
  entryDate: string;
  sourceType: string;
  sourceId?: string | null;
  narration?: string | null;
  totalDebit: number;
  totalCredit: number;
  lines: JournalLine[];
};

export type CreateJournalData = {
  entryDate: string;
  branchId?: string;
  salesPointId: string;
  narration?: string;
  lines: Array<{
    ledgerCode: string;
    debit?: number;
    credit?: number;
    narration?: string;
  }>;
};

const journalAPI = {
  list: async (params?: {
    startDate?: string;
    endDate?: string;
    branchId?: string;
    salesPointId?: string;
  }): Promise<JournalEntry[]> => {
    const res = await api.get("/journals", { params });
    return res.data?.data || [];
  },

  create: async (payload: CreateJournalData): Promise<JournalEntry> => {
    const res = await api.post("/journals", payload);
    return res.data?.data;
  },
};

export default journalAPI;
